import { useEffect, useState } from "react";
import {
  Badge,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import axios from "../../API/axios";
import { getConnectionList } from "../../Services/apiService";
import MessageList from "../Message/MessageList";
import { people, post, svg } from "../../config/imagesLink";
import MessageInteraction from "../Message/MessageInteraction";
// import SmsSharpIcon from '@mui/icons-material/SmsSharp';
import TextsmsSharpIcon from '@mui/icons-material/TextsmsSharp';
import PushPinSharpIcon from '@mui/icons-material/PushPinSharp';
import { ListRowSkeleton } from "@skeleton";
import { useTranslation } from "react-i18next";
import "moment/locale/ar";
import "moment/locale/hi";
import "moment/locale/en-gb";

const { pin } = svg;

export default function TopMessage({ MessagesCount, closeTooltip }) {
  const sessionId = localStorage.getItem("sessionId");
  const { t } = useTranslation();
  const msgCountInfo = localStorage.getItem("MsgCountData")

  const [notifi, setNotifi] = useState([]);
  const [msgCount, setMsgCount] = useState("");
  const formattedTime = moment("aaa").fromNow();
  const language = localStorage.getItem("Lang");
  const localeMap = {
      en: "en",
      ar: "ar",
      hi: "hi",
    };

const locale = localeMap[language] || "en";
  //   const sessionId = localStorage.getItem('sessionId')
  const { UserId } = useParams();
  const [msgId, setMsgId] = useState("");
  const [connectionUser, setConnectionUser] = useState("");
  const [userName, setUserName] = useState("");
  const [chatList, setChatList] = useState("");
  //************************Message List Start  ************************//
  const [isLoading, setIsLoading] = useState(true);
  const [messageList, setmessageList] = useState([]);
  const [show, setShow] = useState(false);
  const [newUser, setNewUser] = useState(false);
  const [page, setPage] = useState(1);
  const [active, setActive] = useState();
  const [archiveActive, setArchiveActive] = useState();
  const [archiveMessage, setArchiveMessage] = useState(false);
    const [isError, setIsError] = useState(true);
  
  const getMessageList = () => {
    setIsLoading(true);

    const data = {
      deviceType: "Web",
      sessionId: sessionId,
    };
    axios
      .post(`Message/GetMessageList`, data)
      .then((response) => {
        // console.log(response);
        const res = response.data.responseData;
        localStorage.setItem(
          "MessageChatId",
          response.data.responseData.chatID
        );

        // setmessageList(res);
        setmessageList(res);
        setIsLoading(false);
          setIsError(false);


      })
      .catch((error) => {
        console.log(error);
         if (error.response.status === 404 || error.status === 404) {
        setIsLoading(false);
        
        setIsError(true);
      } else {
        console.log("error", error.response.status);
      }
      });
  };
  // useEffect(() => {
  //   getMessageList();
  // }, []);

  //************************Message List End  ************************//

  //************************ Connection  List   ************************//
  const [ConnectionList, setConnectionList] = useState([]);
  const [searchconnectList, setSearchconnectList] = useState([]);
  const [searchUserName, setSearchUserName] = useState("");
  // console.log('ConnectionList', ConnectionList);
  const navigate = useNavigate();
  const [unauthorisedModal, setUnauthorisedModal] = useState(false);

  const ConnectionListAll = async (id) => {
    // console.log('calles');
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      pageNumber: page,
      pageSize: 10,
      type: "ConnectionList",
      search: searchUserName,
      langKey: language === "en" ? "" : language,

    };
    try {
      await getConnectionList(data).then((resData) => {
        // console.log("resData", resData);
        // setConnectionList(resData.data.responseData.viewList);
        setIsLoading(false);

        if (searchUserName !== "") {
          // return newPosts;
          setConnectionList([]);
          setSearchconnectList(resData.data.responseData.viewList);
        } else {
          setSearchconnectList([]);
          // setConnectionList((prev) => [
          //   ...prev,
          //   ...resData.data.responseData.viewList,
          // ]);
          // const newPosts = resData.data.responseData.viewList;
          // setPostList((prev) => {
          //   const postSet = new Set(prev.map((post) => post.postId));
          //   const uniqueNewPosts = newPosts.filter(
          //     (post) => !postSet.has(post.postId)
          //   );
          //   return [...prev, ...uniqueNewPosts];
          // });
          setConnectionList((prev) => {
            const newViewList = resData?.data?.responseData?.viewList.filter(
              (item) =>
                !prev.some((prevItem) => prevItem.cnctnId === item.cnctnId)
            );
            return [...prev, ...newViewList];
          });
        }
      });
    } catch (error) {
      if ((error.code === 'ERR_NETWORK' && sessionId) || (error.code === "ERR_BAD_REQUEST" && sessionId)) {
        setUnauthorisedModal(true)
      }
    }
  };

  useEffect(() => {
    if (show) {
      ConnectionListAll();
    }
  }, [show, searchUserName]);

  //************************Connection List ************************//

  const handelInfiniteScroll = async () => {
    try {
      if (
        window.innerHeight + document.documentElement.scrollTop + 1 >=
        document.documentElement.scrollHeight
      ) {
        // setLoading(true);
        setPage((prev) => prev + 1);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handelInfiniteScroll);
    return () => window.removeEventListener("scroll", handelInfiniteScroll);
  }, []);

  const handleSendMessage = (item) => {
    const userExistsInMessageList = messageList.some(
      (message) => message.chatInfo.toUserId === item.connectsWithUserUid
    );
    if (userExistsInMessageList) {
      // Perform the action if user exists in the message list
      // console.log("User exists in the message list");
      // Call the function you need to execute when user exists
    } else {
      setChatList("");
      setConnectionUser(item.connectsWithUserUid);
      setUserName(item.connectsWithUserName);
      setShow(false);
    }
  };

  //************************Archived List Start  ************************//
  // const [archivedList, setArchivedList] = useState([]);
  // const getArchivedList = () => {
  //   const data = {
  //     deviceType: "Web",
  //     sessionId: sessionId,
  //   };
  //   axios
  //     .post(`Message/GetArchivedMessageList`, data)
  //     .then((response) => {
  //       const res = response.data.responseData;
  //       setArchivedList(res);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };
  // useEffect(() => {
  //   getArchivedList();
  // }, []);
  //************************Archived List End  ************************//

  //************************Message List Start  ************************//
  const [isLoadingChat, setIsLoadingChat] = useState(true);

  const [chatInfo, setChatInfo] = useState("");
  // console.log('chatList', chatList);
  const getChatList = () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      // "msgID": msgId,
      toUserUid: UserId,
    };
    localStorage.setItem("toUserUid", data.toUserUid);
    axios
      // .post(`Message/GetUserChat`, data)
      .post(`Message/GetUserAllChat`, data)
      .then((response) => {
        // console.log(response);
        setIsLoadingChat(false);
        const res = response.data.responseData.chatList;
        //alert('test');
        var chatId = localStorage.getItem("DeletedChatId");
        // setChatList(res);
        if (Array.isArray(res)) {
          setChatList(res);
          //  setAllUserChats(prev => ({
          //     ...prev,
          //     [UserId]: res // Store the fetched data for this user
          // }));
        } else {
          console.error("chatList is not an array", res);
          setChatList([]); // prevent crashing
        }
        setChatInfo(response.data.responseData.messageInfo);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (UserId) {
      getChatList();
    }
  }, [UserId]);

  //************************Message List End  ************************//

  const [showClear, setShowClear] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const [activeTab, setActiveTab] = useState(1);
  const [isShown, setIsShown] = useState(true);

  //************************Message Count End  ************************//

  //  const MessagesCount = async () => {
  //     const data = {
  //       deviceType: "Web",
  //       sessionId: sessionId,
  //     };
  //     try {
  //       // setLoading(true);
  //       await axios
  //         .post(`Message/AllUnreadMsgsCount`, data)
  //         .then((resData) => {
  //           // setMsgCount(resData.data.responseData);

  //           if (msgCount !== resData.data.responseData) {
  //             setMsgCount(resData.data.responseData);
  //           }
  //           console.log("messagecountTotal" ,resData.data.responseData );

  //         });
  //     } catch (error) {
  //       console.log(error);

  //     }
  //   }; 

  //    useEffect(() => {
  //     const sessionId = localStorage.getItem("sessionId");
  //     if (sessionId) {
  //       (async () => { 
  //         await Promise.all([ 
  //           MessagesCount()
  //         ]);
  //       })();
  //     } 
  //   }, []);


  return (
    <>
      <UncontrolledDropdown
        tag=""
        className="dropdown-notification nav-item me-25"
      >
        <DropdownToggle
          tag="a"
          className="nav-link"
          href="/"
          onClick={(e) => e.preventDefault()}
        >

          <TextsmsSharpIcon className="material-symbols-sharp" onClick={() => {
            getMessageList();
          }} />
          {msgCountInfo > 0 ? (
            <Badge pill color="danger" className="badge-up notifictaionBadge">
              {msgCountInfo > 99 ? "99+" : msgCountInfo}
            </Badge>
          ) : (
            ""
          )}

        </DropdownToggle>
        <DropdownMenu end tag="ul" className="dropdown-menu-media mt-0 notificationDropdown topmessages" onMouseEnter={closeTooltip}
          onMouseLeave={closeTooltip}>
          {/* {messageList.length === 0 ? <h4 className="notification-title mb-0 me-auto text-center">No Message</h4> : */}
          <>

            <li className="dropdown-menu-header">
              <DropdownItem className="d-flex" tag="div" header>
                <h4 className="notification-title mb-0 me-auto">{t("Notifications.Messages")}</h4>
              </DropdownItem>
            </li>

            {isLoading ? (
              <ListRowSkeleton count={5} rowHeight={50} showAvatar />
            ) :isError || messageList.length === 0 ? (
              <div className="text-center errorimg my-3">
                {/* <img src={emptyMessageImage} alt="No Messages" width={80} /> */}
                <img src={post.errorSmall} alt="Error" width={200} />

                {/* <p className="text-muted mt-2">{t("Notifications.No messages found")}</p> */}
              </div>
            ) : (

              messageList.slice(0, 5).map((item, index) => {
                const formattedTime = moment(item.lastMsgTime).fromNow();
                 const now = moment();
                 const itemTime = moment.utc(item.lastMsgTime);
                 const duration = moment.duration(now.diff(itemTime));

                 const years = duration.years();
                 const months = duration.months();
                 const days = duration.days();
                 const hours = duration.hours();
                 const minutes = duration.minutes();

                 let result = "";

                 if (years > 0) {
                   result = `${years} ${t("Notifications.Year")}${years > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                 } else if (months > 0) {
                   result = `${months} ${t("Notifications.Month")}${months > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                 } else if (days > 0) {
                   result = `${days} ${t("Notifications.Day")}${days > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                 } else if (hours > 0) {
                   result = `${hours} ${t("Notifications.Hour")}${hours > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                 } else if (minutes > 0) {
                   result = `${minutes} ${t("Notifications.Minute")}${minutes > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                 } else {
                   result = t("Notifications.Just Now");
                 }

                               {/* const now = moment.utc().local();
                                    const itemTime = moment.utc(item.lastMsgTime).local();
                
                                    const diffSeconds = now.diff(itemTime, "seconds");
                                    const diffMinutes = now.diff(itemTime, "minutes");
                                    const diffHours = now.diff(itemTime, "hours");
                                    const diffDays = now.diff(itemTime, "days");
                
                                    const diffMonths = now.diff(itemTime, "months", true);
                                    const diffYears = now.diff(itemTime, "years", true);
                
                                    let result = "";
                 
                                    if (diffSeconds < 60) {
                                      result = t("Notifications.Just Now");
                                    }
                 
                                    else if (diffMinutes < 60) {
                                      result =
                                        diffMinutes === 1
                                          ? `${diffMinutes} ${t("Notifications.Minute")} ${t("Notifications.Ago")}`
                                          : `${diffMinutes} ${t("Notifications.Minutes")} ${t("Notifications.Ago")}`;
                                    }
                 
                                    else if (diffHours < 24) {
                                      result =
                                        diffHours === 1
                                          ? `${diffHours} ${t("Notifications.Hour")} ${t("Notifications.Ago")}`
                                          : `${diffHours} ${t("Notifications.Hours")} ${t("Notifications.Ago")}`;
                                    }
                 
                                    else if (diffDays < 30) {
                                      result =
                                        diffDays === 1
                                          ? `${diffDays} ${t("Notifications.Day")} ${t("Notifications.Ago")}`
                                          : `${diffDays} ${t("Notifications.Days")} ${t("Notifications.Ago")}`;
                                    }
                 
                                    else if (diffMonths < 12) {
                                      const displayMonth =
                                        diffMonths >= 0.75 && diffMonths < 1.25
                                          ? 1
                                          : Math.round(diffMonths * 2) / 2;
                
                                      result =
                                        displayMonth === 1
                                          ? `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Month")} ${t("Notifications.Ago")}`
                                          : `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Months")} ${t("Notifications.Ago")}`;
                                    }
                 
                                    else {
                                      const displayYear =
                                        diffYears >= 0.75 && diffYears < 1.25
                                          ? 1
                                          : Math.round(diffYears * 2) / 2;
                
                                      result =
                                        displayYear === 1
                                          ? `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Year")} ${t("Notifications.Ago")}`
                                          : `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Years")} ${t("Notifications.Ago")}`;
                                    } */}
                

                return (
                  <li className="dropdown-menu-header" key={index}>
                    <DropdownItem className="topnotification d-flex align-items-center px-0">
                      <div className="MessageListCont" style={{ textWrap: 'auto' }}>
                        <Link to={`/Message/${item?.chatInfo?.toUserUid}`} onClick={() => { }}>
                          <div
                            onClick={() => {
                              setActive(index);
                              setMsgId(item.chatInfo.msgID);
                            }}
                            className={`${isShown ? "d-block" : "d-md-block d-none"} pointer`}
                          >
                            <div
                              className={`${active === index ? "activeMsg" : ""} message-cards d-flex align-items-center`}
                            >
                              <div className="me-3 ms-2 topnotification">
                                <img
                                  src={item.chatInfo.toUserImage || people.DefaultProfile}
                                  alt=""
                                  width={40}
                                  height={40}
                                  style={{ borderRadius: "50px" }}
                                />
                              </div>
                              <div className="msg-content w-100 me-2">
                                <div className="name-time d-flex justify-content-between align-items-baseline">
                                  <div className="message-user-name darkmode f-12 f-600 d-flex">
                                   <span className="msg-title">
                                     {item.chatInfo.toUserFullName}
                                   </span> 
                                    {item?.isPined && (
                                      <span className="ms-2">
                                        <PushPinSharpIcon className="material-symbols-sharp pin-icon" />
                                      </span>
                                    )}
                                  </div>
                                  <div className="message-time darkmode f-10 f-400 text-end" style={{ width: '65px' }}>
                                    {/* {moment.utc(item.lastMsgTime).local().format("LT")} */}
                                    {result}
                                  </div>
                                </div>
                                <div className="d-flex justify-content-between">
                                  <div
                                    className={`${item.lastMsgIsRead === false ? "fw-bolder f-14" : "fw-normal f-10"
                                      } messageText darkmode`}
                                  >
                                    <p className="messageText">
                                      {item?.isOwned && `${t("Notifications.You")}:  `}
                                      {/* {item.lastMsg.split(' ').slice(0, 4).join(' ')} */}
                                      {/* {item.lastMsg.split(' ').length > 4 && '...'} */}
                                      {(item.lastMsg?.length > 15 ? item.lastMsg.slice(0, 15) + "..." : item.lastMsg)}

                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    </DropdownItem>
                  </li>
                );
              })

            )}



            <li className="dropdown-menu-footer">
              <Link tag={Link} to="/Message/All">
                <button
                  type="submit"
                  className="wljPrimaryBtn d-flex align-items-center mt-2 mb-2 noti-btn"
                >
                  {t("Notifications.View all messages")}
                </button>
              </Link>
            </li>
          </>
          {/* // } */}
        </DropdownMenu>
      </UncontrolledDropdown>
      {
        unauthorisedModal && (
          <div
            className="modal fade show postAdd"
            tabIndex="-1"
            role="dialog"
            style={{ display: "block" }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content d-flex justify-content-around p-2">
                <div className="d-flex justify-content-between align-items-center p-2">
                  <div>
                    <h4 className="text-center AdBlocker">{t("Recommendations.Warning")}</h4>
                    <p className="text-center ad-p">
                      {t("modals.Your session has expired or you are not authorized to access this resource. Please log in again to continue.")}
                    </p>
                    <div className="text-center m-auto mt-3">
                      <button
                        type="button"
                        className="mainBtn1 "
                        onClick={() => {
                          setUnauthorisedModal(!unauthorisedModal)
                          navigate("/SignIn");
                          localStorage.clear();
                          sessionStorage.removeItem('hasModalShown');
                        }}
                      >
                        {t("modals.login")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
    </>

  );

}
